import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import Image = Phaser.GameObjects.Image;
import Text = Phaser.GameObjects.Text;
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ShopTab extends Phaser.GameObjects.Container {

    private selectCallback!: () => unknown;

    private tabImage!: Image;
    private tabText!: Text;
    private blocked!: boolean;

    constructor(scene: Scene, x: number, y: number, tabName: string, width: number,
                selected: boolean, blocked: boolean, selectCallback: () => unknown, fontSize: number) {
        super(scene);

        this.scene = scene;
        this.x = x * CU.S;
        this.y = y * CU.S;
        const self = this;
        this.selectCallback = selectCallback;
        this.blocked = blocked;

        this.tabImage = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_SHOP_UI, selected ? Keys.UI_SHOP_TAB_ACTIVE : Keys.UI_SHOP_TAB_INACTIVE)
            .setInteractive();
        SpriteUtils.setDispSize(this.tabImage, width * CU.S, 50 * CU.S);

        this.tabText = TextUtils.addTextByFamily(this.scene, tabName, 0, 4, blocked ? '#a8a8a8' : '#ffffff', fontSize,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        this.tabImage.on('pointerup', () => {
            self.select();
        });

        this.add([this.tabImage, this.tabText]);

        if (blocked) {
            let pageLock = SpriteUtils.addImage(this.scene, this.tabText.getTopLeft().x! - 10, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PAGE_LOCK);
            this.add([pageLock]);
        }

    }

    public select() {
        if (!this.blocked) {
            this.setSelected(true);
        }
        if (this.selectCallback != null) {
            this.selectCallback();
        }
    }

    public setSelected(selected: boolean): void {
        SpriteUtils.setSprite(this.scene, this.tabImage, Keys.ATLAS_SHOP_UI, selected ? Keys.UI_SHOP_TAB_ACTIVE : Keys.UI_SHOP_TAB_INACTIVE);
    }

    public setTabText(txt: string) {
        this.tabText.setText(txt);
    }
}